import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Radio, LogIn } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("admin@audrivio.com");
  const [password, setPassword] = useState("Admin1234!");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bentornato");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenziali non valide");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-xd-dark flex items-center justify-center px-4 font-admin">
      <div className="max-w-sm w-full">
        <div className="text-center mb-6">
          <div className="inline-flex w-12 h-12 rounded-xl bg-gradient-to-br from-xd-cyan to-xd-cyanHover items-center justify-center"><Radio className="w-6 h-6 text-xd-dark" /></div>
          <div className="mt-3 font-display text-2xl font-semibold text-white">audrivio Admin</div>
          <div className="text-xs text-slate-400 mt-1">Accedi al pannello di amministrazione</div>
        </div>
        <form onSubmit={submit} className="bg-xd-dark2 border border-xd-darkBorder rounded-xl p-6 space-y-4">
          <div>
            <label className="text-[10px] font-mono-tech uppercase tracking-widest text-slate-400">Email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" className="bg-xd-dark border-xd-darkBorder text-white mt-1" required />
          </div>
          <div>
            <label className="text-[10px] font-mono-tech uppercase tracking-widest text-slate-400">Password</label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" className="bg-xd-dark border-xd-darkBorder text-white mt-1" required />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full btn-cta rounded-lg py-2.5 text-sm inline-flex items-center justify-center gap-2 disabled:opacity-50">
            <LogIn className="w-4 h-4" /> {loading ? "Accesso…" : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
